import { FC } from 'react';
import AccordionContent from 'ui-kit/components/accordion/AccordionContent';
import PaymentForm from '../components/PaymentForm';
import { PaymentAccordionProps } from '../types';

const PaymentAccordion: FC<PaymentAccordionProps> = ({
  payment,
  index,
  expanded,
  onChange,
  onDelete,
  onToggle,
  validationErrors,
  clearValidationErrors,
}) => {
  const handleDelete = () => {
    onDelete();
  };

  const handleExpandChange = (expand: boolean, id: number | string) => {
    onToggle();
  };

  return (
    <AccordionContent
      id={payment.id || `payment-${index}`}
      title={`Payment No. ${index + 1}`}
      expanded={true}
      hideSubtitle={true}
      data-testid={`fincen-payment-${index}-accordion`}
      data-testid-edit={`fincen-payment-${index}-edit-button`}
      data-testid-delete={`fincen-payment-${index}-delete-button`}
      onDelete={handleDelete}
      onExpandChange={handleExpandChange}
    >
      <PaymentForm
        payment={payment}
        index={index}
        onChange={onChange}
        onDelete={onDelete}
        validationErrors={validationErrors}
        clearValidationErrors={clearValidationErrors}
      />
    </AccordionContent>
  );
};

export default PaymentAccordion;
